import IconDark from "@/assets/icons/close-button.svg"
import Icon from "@/assets/icons/close-button-white.svg"
import { Pressable, type StyleProp, type ViewStyle } from "react-native"
import { cn } from "@/components/util/cn"

interface BFCloseButtonProps {
  dark?: boolean
  onPress?: () => void
  className?: string
  style?: StyleProp<ViewStyle>
}

export const BFCloseButton = ({
  dark = false,
  onPress,
  className,
  style,
}: BFCloseButtonProps) => {
  return (
    <Pressable
      testID="closeButton"
      onPress={onPress}
      hitSlop={20}
      style={style}
      className={cn("p-1 flex  justify-center items-center", className)}
    >
      {dark ? <IconDark /> : <Icon />}
    </Pressable>
  )
}
